var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLikeActiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_506_1532)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.52721 31.8265C9.52721 32.9327 8.60995 33.823 7.53082 33.823H2.00029C0.894187 33.823 0.00390625 32.9327 0.00390625 31.8265V16.1511C0.00390625 15.0449 0.894187 14.1546 2.00029 14.1546H7.50385C8.60995 14.1546 9.50023 15.0449 9.50023 16.1511L9.52721 31.8265ZM32.9443 19.5236C34.1313 20.4679 34.3202 22.1946 33.3759 23.3817C32.9982 23.8674 32.4587 24.1911 31.8652 24.326C33.0522 25.2703 33.241 26.9971 32.2968 28.1572C31.9191 28.6429 31.3796 28.9666 30.7591 29.1285C31.9461 30.0728 32.1349 31.7995 31.1637 32.9866C30.6511 33.6342 29.8688 34.0119 29.0324 34.0119L13.52 33.85C12.4139 33.85 11.5236 32.9597 11.5236 31.8535V16.1511C11.5236 13.6689 19.7197 6.80819 19.8599 6.6541C20 6.5 19.7789 0.988281 20.8581 0.988281C22.7196 0.988281 25.0667 1.68976 25.0667 5.79073C25.0667 9.40606 22.6926 14.1006 22.6926 14.1006H32.2968C33.8076 14.1006 35.0216 15.3147 35.0216 16.8256C35.0756 18.1476 34.1853 19.2538 32.9443 19.5236Z",
    fill: "#FC7336"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_506_1532"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeActiveIcon);
export default __webpack_public_path__ + "static/media/like_active_icon.88d84428c5d271bf98d802427ee0a941.svg";
export { ForwardRef as ReactComponent };